import { Button, Chip, Paper, Stack, Typography } from "@mui/material";
import { useContext } from "react";
import { AppContext } from "../../AppContext";
import { DataContext } from "../DataContext";
import { ArrowBack, AutoGraph, Co2, ConnectWithoutContact, Dashboard, Folder, Logout, Map, Person } from "@mui/icons-material";
import UserLabel from "../ui/UserLabel";
import { Link } from "react-router-dom";
import $auth from "../../services/$auth";
import $cookies from "../../services/$cookies";
import { variables } from "../../styles/abstract/variables";



function Header(props) {
  const {user, selected} = useContext(AppContext);
  const {projectData, projects} = useContext(DataContext);
  let parcels = [];
  let project = null;
  try {
    project = projects.results.find((project) => JSON.stringify(project.id) === selected.toString());
    parcels = [...projectData[selected].parcels];
  } catch {

  }

  const logout = async () => {
    try {
      await $auth.logout($cookies.get('refresh'));
      window.location.reload();

    } catch (e) {
      window.location.reload();

    }
  }

  return (
    <Stack component={Paper} sx={{ zIndex: 10, padding: '15px', borderRadius: 0, position: 'relative' }} className="co-background-primary" elevation={3} direction="row" spacing={2} justifyContent="space-between">
      <div>
        {Boolean(selected) && <Chip variant="filled" color="secondary" label={project.getName()}  sx={{fontWeight: 'bold', mr: '5px', color: variables.primary}} size="large" />}
        {/* <Fab size="small" color='secondary' children={<Menu style={{color: '#fff'}} />} /> &nbsp;&nbsp; */}
        {window.location.pathname !== '/dashboard/projects' && <Button component={Link} to="/dashboard/projects" sx={{ color: '#fff' }} color="secondary" startIcon={<ArrowBack />}>BACK TO FARMS</Button>}

        {/* <Button component={Link} to="/dashboard/profile" sx={{ color: '#fff' }} color="secondary" startIcon={<Person />}>PROFILE</Button> */}
        {/* {user?.user_type !== 1 && <Button component={Link} to="/dashboard/farmers" sx={{ color: '#fff' }} color="secondary" startIcon={<ConnectWithoutContact />}>FARMERS</Button>} */}
        {Boolean(selected) && <Button component={Link} to={`/dashboard/project/${selected}/carbon-management-system/`} sx={{ color: '#fff' }} color="secondary" startIcon={<Dashboard fontSize='large' />}>Dashboard</Button>}
        {Boolean(selected) && <Button component={Link} to={`/dashboard/project/${selected}/map/`} sx={{ color: '#fff' }} color="secondary" startIcon={<Map />}>MAP</Button>}
        {/* <Button component={Link} to="/dashboard/soc-sequestration" sx={{ color: '#fff' }} color="secondary" startIcon={<AutoGraph />}>SOC SEQUESTRATION</Button> */}
        {Boolean(selected) && <Button component={Link} to={`/dashboard/project/${selected}/carbon-emissions/`} sx={{ color: '#fff' }} color="secondary" startIcon={<Co2 fontSize='large' />}>EMISSIONS</Button>}

        <UserLabel />
      </div>
      <div>
        <Button onClick={logout} sx={{ color: '#fff' }} color="secondary" startIcon={<Logout />}>Logout</Button>
      </div>
    </Stack>
  )
}

export default Header;